module.exports = __webpack_public_path__ + "static/media/white-x.610b5343.svg";